import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  FileUploaderDropzoneAntigen,
  FileUploaderButton,
  FileUploaderGreyText,
} from "./DocumentUploader.styles";

export const GenericFileUploadInputContent = () => {
  const { t } = useTranslation();

  return (
    <FileUploaderDropzoneAntigen key="custom">
      <FileUploaderButton>
        {t("upfrontPayment.fileUpload.chooseFile")}
      </FileUploaderButton>
      <br />
      <Box>
        <FileUploaderGreyText>
          {t("upfrontPayment.fileUpload.or")}
        </FileUploaderGreyText>
        <FileUploaderGreyText>
          {t("upfrontPayment.fileUpload.dragAndDrop")}
        </FileUploaderGreyText>
      </Box>
    </FileUploaderDropzoneAntigen>
  );
};
